var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 5.28756,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none"
    },
    id: "rect2",
    width: 500,
    height: 110,
    x: 0,
    y: 0,
    ry: 55,
    rx: 55
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 5.28803,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect2-7",
    width: 500,
    height: 110,
    x: 0,
    y: 195,
    ry: 55,
    rx: 55
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 5.28803,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect2-7-5",
    width: 500,
    height: 110,
    x: 0,
    y: 390,
    ry: 55,
    rx: 55
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.f1a710f13f5e2ecaeba80959ebe21cd1.svg";
export { ForwardRef as ReactComponent };